import { useEffect, useState } from 'react';
import { EventEmitter, TId } from '@apia/util';
import { usePanelIdentity } from '../common';

class PanelNetworkStateEmitter extends EventEmitter<{
  stateChange: {
    panelId: TId;
    isConnected: boolean;
  };
}> {}

export const panelNetworkStateEmitter = new PanelNetworkStateEmitter();

/**
 * Permite saber en todo momento si el panel actual tuvo un error en su
 * conexión de red
 */
export const usePanelNetworkState = () => {
  const [isConnected, setIsConnected] = useState(true);

  const { panelId } = usePanelIdentity();

  useEffect(() => {
    return panelNetworkStateEmitter.on('stateChange', (ev) => {
      if (ev.panelId === panelId && ev.isConnected !== isConnected)
        setIsConnected(ev.isConnected);
    });
  }, [isConnected, panelId]);

  return isConnected;
};
